import type { HexCoord, HexGrid } from "../types.ts";
import { pixelToHex, coordToKey } from "../engine/hex.ts";
import { computeHexLayout } from "./hex-renderer.ts";

export function detectHexHit(
  mx: number,
  my: number,
  grid: HexGrid,
  width: number,
  height: number
): HexCoord | null {
  const { hexSize, cx, cy } = computeHexLayout(grid, width, height);
  const coord = pixelToHex(mx, my, hexSize, cx, cy);
  const key = coordToKey(coord);

  if (grid.cells.has(key)) {
    return coord;
  }
  return null;
}
